import { Alert, Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from '../../api';
import { ApiError } from '../errors';

type SendTestLeadProps = {
  integrationId: 'amocrm' | 'bitrix' | 'roistat' | 'get-response' | 'webhook' | 'get-course' | 'telegram';
  campaignId: number;
  params?: any;
  disabled?: boolean;
};

export const SendTestLead: FC<SendTestLeadProps> = ({ integrationId, campaignId, params, disabled }) => {
  const [send, sendResult] = api.useSendTestLeadMutation();
  const { t } = useTranslation();

  return (
    <>
      <Button
        disabled={sendResult.isLoading || disabled}
        onClick={() => {
          send({ integrationId, campaignId, params });
        }}
        variant="contained"
        className="send-test-lead-button"
      >
        {t('integrations.sendTestLead')}
      </Button>

      {sendResult.isError && <ApiError error={sendResult.error} withMargin />}
      {sendResult.isSuccess && (
        <Alert severity="success" variant="filled" sx={{ marginTop: '12px' }}>
          {t('integrations.sendTestLeadSuccess')}
        </Alert>
      )}
    </>
  );
};
